<template>
  <v-container class="productos-list-container">
    <go-back
      :onlyAndroid="true"
      :forceRoute="true"
      :routeName="previousPage"
      label="Volver al inicio"
    ></go-back>

    <!-- Banner promocional (grupo por cantidad y/o forma de pago) -->
    <promo-banner :grupo-id="grupoIdProductos"></promo-banner>

    <v-row class="mt-1" dense v-show="!loading">
      <v-col v-for="(p,i) in products" :key="i" cols="12" class="py-0">
        <product-mobile-card :product="p"></product-mobile-card>
      </v-col>
    </v-row>
    <v-row class="mt-4" v-if="loading">
      <v-col v-for="i in 3" cols="6" :key="`${i}ab`">
        <v-skeleton-loader
            type="card"
            :loading="loading">
        </v-skeleton-loader>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import GoBack from '@/components/GoBack.vue'
import ProductMobileCard from '../components/cards/ProductMobileCard.vue'
import PromoBanner from '../components/PromoBanner.vue'
import { restoreCatalogScroll, peekCatalogPosition } from '@/helpers/catalogScroll.js'

export default {
  components: { GoBack, ProductMobileCard, PromoBanner },
  name: 'ProductosListMobile',
  computed: {
    ...mapState('Categorias', ['currentCategoria']),
    ...mapState('App', ['tiendaActual']),
    grupoIdProductos () {
      // Obtener el GrupoId del primer producto que tenga GrupoDescuento
      if (this.products && this.products.length > 0) {
        const productoConGrupo = this.products.find(p => p.GrupoDescuento && p.GrupoDescuento.GrupoId)
        const grupoId = productoConGrupo ? productoConGrupo.GrupoDescuento.GrupoId : null
        return grupoId
      }
      return null
    }
  },
  methods: {
    ...mapActions('Productos', ['fetchProducts'])
  },
  data () {
    return {
      loading: false,
      products: [],
      previousPage: null,
      mesaId: null
    }
  },
  async mounted () {
    const code = this.$clientCode()
    if (!this.currentCategoria) return this.$router.push({ name: 'Home', params: { client: code } })
    if (!this.currentCategoria.id) return this.$router.push({ name: 'Home', params: { client: code } })
    const shouldRestore = !!peekCatalogPosition()
    if (!shouldRestore) this.$vuetify.goTo(0)
    this.loading = true
    this.products = await this.fetchProducts(this.currentCategoria.id || this.currentCategoria)
    this.loading = false
    this.previousPage = this.$route.params.mesaId ? `/tienda/${code}/mesa/${this.$route.params.mesaId}` : `/tienda/${code}`
    this.mesaId = this.$route.params.mesaId
    if (shouldRestore) {
      this.$nextTick(() => {
        setTimeout(() => restoreCatalogScroll(this.$route), 100)
      })
    }
  },
  watch: {
    '$route.params.client': {
      immediate: false,
      async handler () {
        const code = this.$clientCode()
        this.loading = true
        this.products = []
        if (!this.currentCategoria || !this.currentCategoria.id) {
          this.loading = false
          return this.$router.push({ name: 'Home', params: { client: code } })
        }
        this.products = await this.fetchProducts(this.currentCategoria.id)
        this.loading = false
      }
    },
    currentCategoria: {
      immediate: false,
      async handler (val) {
        if (!val) return
        this.loading = true
        this.products = []
        this.products = await this.fetchProducts(val.id || val)
        this.loading = false
      }
    }
  }
}
</script>
<style scoped>
.productos-list-container {
  padding-top: 76px; /* Espacio para navbar (56px) + barra de categorías (~20px) */
}
</style>
